import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const WithdrawalOrder = ({ order }) => {
  const { t } = useTranslation();
  const { authorization } = useSelector((state) => state.auth);
  const currency = authorization?.isEmirate
    ? t("buyAndSupply.aed")
    : t("pendingWithdrawals.egp");

  return (
    <div className="orders__order">
      <div className="orders__description">
        <h3
          className="orders__paragraph text-truncate fsize-5 fw-bold"
          title={order?.item}
        >
          {order?.item}
        </h3>
      </div>

      <div className="row m-0">
        <div className="col-md-6 px-0 pe-md-2">
          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.category")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.categoryName}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.quantity")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.sealedQuantity} {t("pendingWithdrawals.kg")}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.sellingDate")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.sellingDate}
            </span>
          </div>
        </div>

        <div className="col-md-6 px-0 ps-md-2">
          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.Price")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.totalOfferPriceBeforeCommission} {currency}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.commission")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.commission} {currency}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.managementFees")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.managementFees} {currency}
            </span>
          </div>

          <div className="d-flex align-items-center gap-2">
            <span className="orders__paragraph fw-bold fsize-9">
              {t("pendingWithdrawals.totalAfterCommission")}:
            </span>
            <span className="fsize-9 orders__qty fw-500">
              {order?.totalOfferPriceAfterCommission} {currency}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalOrder;
